// extracted by mini-css-extract-plugin
export default {"changeLink":"CK-z","disabled":"DK-z","inline":"EK-z"};